import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(<StrictMode data-id="element-107" data-mp="21ah5igfe953k">
    <App data-id="element-108" data-mp="219xzny30q75w" />
  </StrictMode>);